import { CurrencyPipe } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { get, isNumber, isString } from 'lodash';
import moment from 'moment';

type InterpolatedValueFormatter = (value: string) => string;

@Injectable({ providedIn: 'root' })
export class InterpolationService {
  private readonly currencyPipe = inject(CurrencyPipe);

  private readonly formatters: Record<string, InterpolatedValueFormatter> = {
    date: value => this.formatDate(value),
    dateOnly: value => this.formatDateOnly(value),
    currency: value => this.formatCurrency(value),
  };

  public interpolateFromObject(template: string, obj: Record<string, any>): string {
    return template.replace(/\{([\w.]+)(?:\|(\w+))?\}/g, (match, key, format) => {
      const value = get(obj, key);
      if (value === undefined) return match;
      if (format && this.formatters[format]) return this.formatters[format](value);
      return value;
    });
  }

  private formatDate(value: unknown) {
    if (isString(value) && moment(value, true).isValid()) {
      return moment(value).format('MM/DD/YYYY hh:mm A');
    }
    return `${value}`;
  }

  private formatDateOnly(value: unknown) {
    if (isString(value) && moment(value, true).isValid()) {
      return moment(value).format('MM/DD/YYYY');
    }
    return `${value}`;
  }

  private formatCurrency(value: unknown) {
    let result: string | null = null;

    if (isNumber(value)) {
      result = this.currencyPipe.transform(value, 'USD');
    }
    return result ?? `${value}`;
  }
}
